var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndexDraft = function SvgIndexDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.241 0 15.5 11.625 11.625 7.75 0 19.491l3.875 3.875 7.75-7.866 3.875 3.875L31 3.875zM0 27.125V31h31v-3.875z",
    shapeRendering: "geometricPrecision"
  })));
};
export default SvgIndexDraft;